var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import clsx from 'clsx';
import { SupportRequestStatus } from 'common/enums/support-request/support-request-status.enum';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
var SupportRequestStatusFilter = function (_a) {
    var value = _a.value, setValue = _a.setValue, className = _a.className, _b = _a.multiple, multiple = _b === void 0 ? true : _b;
    var t = useTranslation().t;
    var allOptions = 'ALL';
    var options = [
        { label: t('Не задан'), value: allOptions },
        { label: t(SupportRequestStatus.closed), value: SupportRequestStatus.closed },
        { label: t(SupportRequestStatus.inProgress), value: SupportRequestStatus.inProgress },
        { label: t(SupportRequestStatus["new"]), value: SupportRequestStatus["new"] },
        { label: t(SupportRequestStatus.pendingCustomer), value: SupportRequestStatus.pendingCustomer },
        { label: t(SupportRequestStatus.updatedByCustomer), value: SupportRequestStatus.updatedByCustomer },
    ];
    var _c = useState([]), filterValue = _c[0], setFilterValue = _c[1];
    useEffect(function () {
        if (value && value.length === 0) {
            setFilterValue([allOptions]);
        }
        else if (value && value.length > 0) {
            setFilterValue(value);
        }
    }, [value]);
    var handleChange = function (event) {
        var value = event.target.value;
        if (value && multiple && value.length > 0) {
            if ((value.length === 1 && value.indexOf(allOptions) > -1) || value[value.length - 1] === allOptions) {
                setValue([]);
            }
            else if (value.length < options.length - 1 && value.indexOf(allOptions) > -1) {
                var filteredValues = value.filter(function (val) { return val !== allOptions; });
                setValue(filteredValues);
            }
            else if (value.length >= options.length - 1 && value.indexOf(allOptions) === -1) {
                setValue([]);
            }
            else {
                setValue(value);
            }
        }
        if (value && multiple && value.length === 0) {
            setValue([]);
        }
        if (value && !multiple) {
            setValue([value]);
        }
    };
    return (_jsx("div", __assign({ className: clsx(className) }, { children: _jsxs(FormControl, __assign({ className: "bg-bg-container-inner-lt \n                dark:bg-bg-container-inner-dk shadow flex flex-wrap cursor-pointer xs:h-36 md:h-44 rounded-8" }, { children: [_jsx(InputLabel, __assign({ className: "xs:h-36 md:h-44", id: "demo-multiple-checkbox-label" }, { children: t('Статус') }), void 0), _jsx(Select, __assign({ className: "xs:h-36 md:h-44 rounded-8", labelId: "demo-multiple-checkbox-label", id: "demo-multiple-checkbox", multiple: multiple, value: filterValue, onChange: handleChange, input: _jsx(OutlinedInput, { className: "bg-bg-container-inner-lt \n\t\t\t\t\tdark:bg-bg-container-inner-dk max-w-256", label: t('Статус') }, void 0), renderValue: function (selected) { return (selected.length > 1 ? t('Выбрано несколько') : t(selected[0])); } }, { children: options.map(function (_a) {
                        var label = _a.label, value = _a.value;
                        return (_jsxs(MenuItem, __assign({ value: value, className: "" }, { children: [_jsx(Checkbox, { checked: filterValue.indexOf(value) > -1 }, void 0), _jsx(ListItemText, { primary: label }, void 0)] }), label));
                    }) }), void 0)] }), void 0) }), void 0));
};
export default SupportRequestStatusFilter;
